import { Col, Modal } from "antd"
import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react"
import FormRequestBookingTour from "./FormRequestBookingTour"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import PageDrawerMobile, { PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"
import { useTranslation } from "react-i18next"

type ModalRequestBookingTourProps = {

}

export type ModalRequestBookingTourRef = {
  open: () => void,
  close: () => void,
}

const ModalRequestBookingTour = forwardRef<ModalRequestBookingTourRef, ModalRequestBookingTourProps>((props, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const isDesktop = useIsDesktop()
  const refDrawerInputBooking = useRef<PageDrawerMobileRef>(null)
  const { t } = useTranslation()

  const handleClose = useCallback(() => {
    if (!isDesktop) {
      refDrawerInputBooking.current?.close()
      return
    }
    setOpen(false)
  }, [isDesktop])

  const handleOpen = useCallback(() => {
    if (!isDesktop) {
      refDrawerInputBooking.current?.open()
      return
    }
    setOpen(true)
  }, [isDesktop])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  if (!isDesktop) {
    return (
      <PageDrawerMobile
        headerProps={{
          title: t("tour.request_book_title"),
          shownRight: false
        }}
        ref={refDrawerInputBooking}
      >
        <Col span={24}>
        <FormRequestBookingTour
          onSuccess={() => refDrawerInputBooking.current?.close()}
          onCancel={() => refDrawerInputBooking.current?.close()}
        />
        </Col>
      </PageDrawerMobile>
    )
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      width={"100rem"}
    >
      <FormRequestBookingTour
        onSuccess={() => handleClose()}
        onCancel={() => handleClose()}
      />
    </Modal>
  )
})

export default ModalRequestBookingTour